import Select, { Props } from "react-select";

export const ReactSelect = ({ value, options = [], ...props }: Props) => {
  return (
    <Select
      value={value}
      options={options}
      isMulti
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      {...props}
      menuPortalTarget={document.body}
      menuPosition="absolute"
      menuPlacement="bottom"
      openMenuOnFocus={false}
      blurInputOnSelect={true}
      captureMenuScroll={false}
    />
  );
};
